import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import login from "../components/login/login.vue"
import echart from "../components/echart/systemDataDisplay.vue"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'echart',
      component: echart
    },
    {
      path: '/echart',
      name: 'echart',
      component: echart
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js